import router from './router'
import rentMessages from './localization'

export default {
  router,
  localization: rentMessages,
}
